import SecurityVerificationModal from 'components/verification/SecurityVerificationModal'
import { SecurityVerificationFiles } from 'components/verification/verificationUtils'

type ListingValidationProps = {
  isLoading: boolean
  verification: string | null
  needsPersonalDocs: boolean
  handleClose: () => void
  handleVerify: (data: {
    files: SecurityVerificationFiles
    propertyId: string | null
  }) => void
}

const ListingValidation = ({
  isLoading,
  verification,
  needsPersonalDocs,
  handleClose,
  handleVerify,
}: ListingValidationProps) => {
  const mode = needsPersonalDocs ? 'owner-initial' : 'owner-subsequent'

  return (
    <SecurityVerificationModal
      isOpen={verification !== null}
      mode={mode}
      isLoading={isLoading}
      onClose={handleClose}
      onSubmit={files =>
        handleVerify({
          files,
          propertyId: verification,
        })
      }
    />
  )
}

export default ListingValidation
